import React from 'react';
import CardComponent from '../Common/CardComponent';

const DeviceFilterBar = ({ filters, setFilters, handleApply, handleReset }) => {
    return (
         <CardComponent title="Filters" subtitle="Find network devices by date or keyword">
        <div className="form-row align-items-end">
          <div className="form-group col-md-4">
            <label className="small mb-1">Search</label>
            <input
              type="text"
              className="form-control"
              placeholder="MAC, Router, Username, IP…"
              value={filters.q}
              onChange={(e) => setFilters((f) => ({ ...f, q: e.target.value }))}
            />
          </div>
          <div className="form-group col-md-3">
            <label className="small mb-1">Date From</label>
            <input
              type="date"
              className="form-control"
              value={filters.from}
              onChange={(e) => setFilters((f) => ({ ...f, from: e.target.value }))}
            />
          </div>
          <div className="form-group col-md-3">
            <label className="small mb-1">Date To</label>
            <input
              type="date"
              className="form-control"
              value={filters.to}
              onChange={(e) => setFilters((f) => ({ ...f, to: e.target.value }))}
            />
          </div>
          <div className="form-group col-md-2 d-flex">
            <button className="btn btn-primary mr-2" onClick={handleApply}>
              <i className="fas fa-filter mr-1" /> Apply
            </button>
            <button className="btn btn-outline-secondary" onClick={handleReset}>Reset</button>
          </div>
        </div>
      </CardComponent>
    );
};

export default DeviceFilterBar;